var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- ko with: props --> <ul class="nfd-dropdown-list"data-bind="css: classNames"><!-- ko foreach: items --> <li class="nfd-dropdown-list-item nfd-dropdown-list-item-hovered"data-bind="click: $parent.onItemClick.bind(null, $data)"> <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko --> </li><!-- /ko --><!-- ko if: $parent.btnMoreIsShow --> <li class="nfd-dropdown-list-item nfd-dropdown-list-item-hovered"data-bind="click: $parent.btnMoreClick, html: $parent.btnMoreContent"></li><!-- /ko --> </ul> <!-- /ko -->';
}
return __p;
};
